import React, { useState } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Modal from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import editTokens from "@amzn/meridian-tokens/base/icon/edit";
import UpsertBreak from "./UpsertBreak";

const UpdateBreakModal = ({
  allBreaks,
  breakConfig,
  onSubmit,
  breakConfigs,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Column>
      <Row alignmentHorizontal="end" widths="fit">
        <Button type="icon" onClick={() => setIsOpen(true)}>
          <div style={{ color: "#0085B3" }}>
            <Icon tokens={editTokens} />
          </div>
        </Button>
      </Row>

      <Modal
        title="Update Event"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeLabel="Close"
      >
        {isOpen && (
          <UpsertBreak
            allBreaks={allBreaks}
            breakConfig={breakConfig}
            onSubmit={(daysOfWeek, updatedBreakConfig) =>
              onSubmit(daysOfWeek, breakConfig, updatedBreakConfig)
            }
            onCancel={() => setIsOpen(false)}
            isEdit={true}
            breakConfigs={breakConfigs}
          />
        )}
      </Modal>
    </Column>
  );
};
export default UpdateBreakModal;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/UpdateBreakModal.js